/**
 * The concrete deployment this build was made for (`VITE_DEPLOYMENT_ENV`, set per branch in
 * .github/workflows/deploy.yml): `development`, `staging`, `csm`, `production` or `preview`.
 *
 * Kept in its own dependency-free module so both `~utils/launchDarklyEnv` (mocked wholesale in some
 * tests) and UI components can read it.
 */
export const deploymentEnv: string = import.meta.env.VITE_DEPLOYMENT_ENV ?? '';

/**
 * csm.maddox.ai: the next release running against the PRODUCTION data, used by our CSMs before it
 * ships to customers. It behaves like production in everything data-related, but is internal-only,
 * sends no product analytics and has every feature flag switched on.
 */
export const isCsmDeployment = deploymentEnv === 'csm';
